import React from "react";
import PropTypes from "prop-types";
import ReactSelect from "react-select";
import moment from "moment";
import { selectOptionType } from "custom-prop-types";
import styles from "components/common/form-elements.scss";
import { Datepicker } from "components/common/datepicker";
import { GSTCalculator } from "components/documents/documents-grid/gst-calculator";
import { optionsMapper, valueMapper, CreatableMultiSelect } from "components/common/select";
import { paymentTypes } from "utils/payment-types";

export const FormComponent = (props) => (
  <div className={ styles["fields-container"] }>
    <h4>{props.title}</h4>
    <Component { ...props } />
  </div>
);

FormComponent.propTypes = {
  title: PropTypes.string.isRequired
};

const Component = (props) => {
  switch (props.type) {
    case "text":
      return <TextInput { ...props } />;
    case "select":
      return <SelectInput { ...props } />;
    case "date":
      return <DatePickerInput { ...props } />;
    case "notes":
      return <NoteInput { ...props } />;
    case "createable":
      return <CreateableSelectInput { ...props } />;
    case "number":
      return <NumberInput { ...props } />;
    case "paymentType":
      return <PaymentTypeInput { ...props } />;
    default:
      return <TextInput { ...props } />;
  }
};

Component.propTypes = {
  type: PropTypes.string.isRequired
};

const TextInput = (props) => (
  <input
    className={ styles.fields }
    onChange={ (e) => props.onChange(props.field, e.target.value) }
    placeholder={ props.placeholder }
    value={ props.value }
  />
);

TextInput.defaultProps = {
  value: ""
};

TextInput.propTypes = {
  field: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string.isRequired,
  value: PropTypes.string
};

const SelectInput = (props) => (
  <ReactSelect
    clearable={ false }
    onChange={ (e) => props.onChange(props.field, e.value) }
    options={ optionsMapper(props.options) }
    placeholder={ props.placeholder }
    searchable={ false }
    value={ valueMapper(props.value) }
  />
);

SelectInput.defaultProps = {
  value: null
};

SelectInput.propTypes = {
  field: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(selectOptionType).isRequired,
  placeholder: PropTypes.string.isRequired,
  value: selectOptionType
};

export const NumberInput = (props) => (
  <input
    className={ styles.fields }
    maxLength={ props.max }
    onChange={ (e) => props.onChange(props.field, e.target.value) }
    placeholder={ props.placeholder }
    type="text"
    value={ normalizeNumber(props.value) }
  />
);

NumberInput.defaultProps = {
  max: null,
  value: ""
};

NumberInput.propTypes = {
  field: PropTypes.string.isRequired,
  max: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

const normalizeNumber = (value) => {
  if (isNaN(value)) {
    return 0;
  }
  return value;
};

export const TaxCalculator = (props) => (
  <div className={ styles.gst }>
    <GSTCalculator { ...props } />
  </div>
);

const PaymentTypeInput = (props) => {
  const className = props.valueType.key === "credit-card" ? styles["credit-card"] : styles["other-payment"];
  return (
    <div className={ className }>
      <SelectInput
        field={ "type" }
        onChange={ props.onChange }
        options={ paymentTypes }
        placeholder={ "Choose a payment type" }
        value={ props.valueType }
      />
      <NumberInput
        field={ "lastFourDigits" }
        max="4"
        name={ "cardNumber" }
        onChange={ props.onChange }
        placeholder={ "Last four..." }
        value={ props.valueNumber }
      />
    </div>
  );
};

PaymentTypeInput.defaultProps = {
  valueNumber: "",
  valueType: null
};

PaymentTypeInput.propTypes = {
  onChange: PropTypes.func.isRequired,
  valueNumber: PropTypes.string,
  valueType: selectOptionType
};

const DatePickerInput = (props) => (
  <Datepicker
    isClearable={ false }
    onDateSelected={ (e) => { props.onChange(props.field, e.utc().format()); } }
    placeholderText="Enter a date"
    selected={ props.value ? moment(props.value) : null }
  />
);

DatePickerInput.propTypes = {
  field: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string
};

const NoteInput = (props) => (
  <textarea
    className={ styles.notes }
    onChange={ (e) => props.onChange(props.field, e.target.value) }
    value={ props.value }
  />
);

NoteInput.propTypes = {
  field: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string
};

const CreateableSelectInput = (props) => <CreatableMultiSelect { ...props } />;



// WEBPACK FOOTER //
// ./src/js/components/documents/documents-grid/dropdown-components.jsx